import script from "./TabBarConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBarConfig.vue?vue&type=script&setup=true&lang=js"

import "./TabBarConfig.vue?vue&type=style&index=0&id=0ebd3c4e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebd3c4e"]])

export default __exports__